import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../services/api.service';

interface BudgetState {
    budgetCheck: any[];
    budgetUtilization: any[];
    isLoading: boolean;
    error: string | null;
}

const initialState: BudgetState = {
    budgetCheck: [],
    budgetUtilization: [],
    isLoading: false,
    error: null,
};

export const checkBudget = createAsyncThunk(
    'budget/check',
    async (budgetData: any, { rejectWithValue }) => {
        try {
            const response = await apiService.checkBudget(budgetData);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);

export const fetchBudgetUtilization = createAsyncThunk(
    'budget/fetchUtilization',
    async (filters: any = {}, { rejectWithValue }) => {
        try {
            const response = await apiService.getBudgetUtilization(filters);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message);
        }
    }
);

const budgetSlice = createSlice({
    name: 'budget',
    initialState,
    reducers: {
        clearBudgetCheck: (state) => {
            state.budgetCheck = [];
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(checkBudget.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(checkBudget.fulfilled, (state, action) => {
            state.isLoading = false;
            state.budgetCheck = action.payload;
        });
        builder.addCase(checkBudget.rejected, (state, action: any) => {
            state.isLoading = false;
            state.error = action.payload;
        });

        builder.addCase(fetchBudgetUtilization.fulfilled, (state, action) => {
            state.budgetUtilization = action.payload;
        });
    },
});

export const { clearBudgetCheck, clearError } = budgetSlice.actions;
export default budgetSlice.reducer;
